import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const TIMEOUT_MS = 15 * 60 * 1000; // 15 minutos
const THROTTLE_MS = 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

// Cierra la sesión de cualquier usuario tras 15 minutos de inactividad.
export default function InactivityLogout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const timer = useRef(null);
  const last = useRef(0);

  useEffect(() => {
    if (!user) return undefined;

    const expire = async () => {
      await logout();
      navigate("/entrar");
      toast("Sesión cerrada por inactividad", {
        description: "Por seguridad hemos cerrado tu sesión. Vuelve a iniciar sesión para continuar.",
      });
    };

    const reset = () => {
      const now = Date.now();
      if (now - last.current < THROTTLE_MS) return;
      last.current = now;
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(expire, TIMEOUT_MS);
    };

    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    last.current = 0;
    reset();

    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, reset));
      if (timer.current) clearTimeout(timer.current);
    };
  }, [user, logout, navigate]);

  return null;
}
